import Vue from 'vue';
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';

// https://docs.vcalendar.io/

Vue.use(VCalendar);
